<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
		<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
			<path stroke-dasharray="20" stroke-dashoffset="20" d="M3 3v18">
				<animate fill="freeze" attributeName="stroke-dashoffset" dur="0.2s" values="20;0" />
			</path>
			<path stroke-dasharray="16" stroke-dashoffset="16" d="M7 12h13.5">
				<animate fill="freeze" attributeName="stroke-dashoffset" begin="0.3s" dur="0.2s" values="16;0" />
			</path>
			<path stroke-dasharray="12" stroke-dashoffset="12" d="M21 12l-7 7M21 12l-7 -7">
				<animate fill="freeze" attributeName="stroke-dashoffset" begin="0.5s" dur="0.2s" values="12;0" />
			</path>
		</g>
	</svg>
</template>
